module.exports = __webpack_public_path__ + "img/bg-cursos-saude.2b232b1b.jpg";